export default "__VITE_ASSET__z4gD4lS1__"